import { Component, OnInit } from '@angular/core';
import { PreferenceService } from '../../../services/preference.service';
import { Router,NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-tender-alert',
  templateUrl: './tender-alert.component.html',
  styleUrls: ['./tender-alert.component.scss']
})
export class TenderAlertComponent implements OnInit {
  isPrefence:boolean = true;
  constructor(private router: Router,private preferenceService: PreferenceService) { }

  ngOnInit(): void {
    this.getPreference();
  }

  getPreference(){
    this.preferenceService.getByUser().subscribe(resp => {
      if(resp.data == null){
        this.isPrefence = true;
      }else{
        this.isPrefence = false;
      }
    });
  }

  notification(){
    this.router.navigate(['./settings/notification']);
  }
}
